import { useEffect, useState } from 'react'
import { chartBasicColors, getColorMapForIds } from '@/utils/color/palette'

export { chartBasicColors }

export const useColorBySchool = (initialSelectedSchools: string[]) => {
  const [coloredSchools, setColoredSchools] = useState<string[]>(initialSelectedSchools)
  const [colorForEachSchool, setColorForEachSchool] = useState<{ [schoolId: string]: string }>({})

  useEffect(() => {
    const map = getColorMapForIds(coloredSchools)
    setColorForEachSchool(map)
  }, [coloredSchools])

  return { colorForEachSchool, setColoredSchools }
}
